import View from './View';
import SemanticDividerSchema from './schema';
import icon from '@plone/volto/icons/divide-horizontal.svg';

const SemanticDividerBlock = {
  id: 'w_divider',
  title: 'Divider',
  view: View,
  icon: icon,
  group: 'wildcard',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: SemanticDividerSchema,
};

export default SemanticDividerBlock;